import { CheckCircle } from '@phosphor-icons/react'
import React from 'react'
import { Container, Content, Icon, SubValue, Value } from './styled'

interface ModalContentProps {
  // children?: ReactNode
  value?: string
  subvalue?: string
  icon?: string
}

export const ModalContent = ({ icon, value, subvalue }: ModalContentProps) => {
  return (
    <Container>
      {icon ? (
        icon === 'error' ? (
          <Icon>
            <CheckCircle size={46} color="#006598" weight="bold" />
          </Icon>
        ) : (
          <Icon>
            <CheckCircle size={46} color="#006598" weight="bold" />
          </Icon>
        )
      ) : null}

      <Content icon={icon}>
        <Value>{value}</Value>
        <SubValue>{subvalue}</SubValue>
      </Content>
    </Container>
  )
}
